/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const pkg = $root.pkg = (() => {

    /**
     * Namespace pkg.
     * @exports pkg
     * @namespace
     */
    const pkg = {};

    pkg.TraceMsg = (function() {

        /**
         * Properties of a TraceMsg.
         * @memberof pkg
         * @interface ITraceMsg
         * @property {number|null} [activeId] TraceMsg activeId
         * @property {number|null} [appType] TraceMsg appType
         * @property {number|null} [version] TraceMsg version
         * @property {number|null} [techType] TraceMsg techType
         * @property {Uint8Array|null} [uid] TraceMsg uid
         * @property {Uint8Array|null} [token] TraceMsg token
         * @property {Uint8Array|null} [conId] TraceMsg conId
         * @property {number|null} [widgetId] TraceMsg widgetId
         * @property {number|null} [pageId] TraceMsg pageId
         * @property {number|null} [preModId] TraceMsg preModId
         * @property {number|null} [modId] TraceMsg modId
         * @property {number|null} [eventType] TraceMsg eventType
         * @property {number|Long|null} [eventTime] TraceMsg eventTime
         * @property {Uint8Array|null} [deviceId] TraceMsg deviceId
         * @property {number|Long|null} [ip] TraceMsg ip
         * @property {number|null} [lng] TraceMsg lng
         * @property {number|null} [lat] TraceMsg lat
         * @property {number|null} [screenX] TraceMsg screenX
         * @property {number|null} [screenY] TraceMsg screenY
         * @property {Uint8Array|null} [conExt] TraceMsg conExt
         */

        /**
         * Constructs a new TraceMsg.
         * @memberof pkg
         * @classdesc Represents a TraceMsg.
         * @implements ITraceMsg
         * @constructor
         * @param {pkg.ITraceMsg=} [properties] Properties to set
         */
        function TraceMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TraceMsg activeId.
         * @member {number} activeId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.activeId = 0;

        /**
         * TraceMsg appType.
         * @member {number} appType
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.appType = 0;

        /**
         * TraceMsg version.
         * @member {number} version
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.version = 0;

        /**
         * TraceMsg techType.
         * @member {number} techType
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.techType = 0;

        /**
         * TraceMsg uid.
         * @member {Uint8Array} uid
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.uid = $util.newBuffer([]);

        /**
         * TraceMsg token.
         * @member {Uint8Array} token
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.token = $util.newBuffer([]);

        /**
         * TraceMsg conId.
         * @member {Uint8Array} conId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.conId = $util.newBuffer([]);

        /**
         * TraceMsg widgetId.
         * @member {number} widgetId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.widgetId = 0;

        /**
         * TraceMsg pageId.
         * @member {number} pageId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.pageId = 0;

        /**
         * TraceMsg preModId.
         * @member {number} preModId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.preModId = 0;

        /**
         * TraceMsg modId.
         * @member {number} modId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.modId = 0;

        /**
         * TraceMsg eventType.
         * @member {number} eventType
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.eventType = 0;

        /**
         * TraceMsg eventTime.
         * @member {number|Long} eventTime
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.eventTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TraceMsg deviceId.
         * @member {Uint8Array} deviceId
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.deviceId = $util.newBuffer([]);

        /**
         * TraceMsg ip.
         * @member {number|Long} ip
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.ip = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TraceMsg lng.
         * @member {number} lng
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.lng = 0;

        /**
         * TraceMsg lat.
         * @member {number} lat
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.lat = 0;

        /**
         * TraceMsg screenX.
         * @member {number} screenX
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.screenX = 0;

        /**
         * TraceMsg screenY.
         * @member {number} screenY
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.screenY = 0;

        /**
         * TraceMsg conExt.
         * @member {Uint8Array} conExt
         * @memberof pkg.TraceMsg
         * @instance
         */
        TraceMsg.prototype.conExt = $util.newBuffer([]);

        /**
         * Creates a new TraceMsg instance using the specified properties.
         * @function create
         * @memberof pkg.TraceMsg
         * @static
         * @param {pkg.ITraceMsg=} [properties] Properties to set
         * @returns {pkg.TraceMsg} TraceMsg instance
         */
        TraceMsg.create = function create(properties) {
            return new TraceMsg(properties);
        };

        /**
         * Encodes the specified TraceMsg message. Does not implicitly {@link pkg.TraceMsg.verify|verify} messages.
         * @function encode
         * @memberof pkg.TraceMsg
         * @static
         * @param {pkg.ITraceMsg} message TraceMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TraceMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.activeId != null && Object.hasOwnProperty.call(message, "activeId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.activeId);
            if (message.appType != null && Object.hasOwnProperty.call(message, "appType"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.appType);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.version);
            if (message.techType != null && Object.hasOwnProperty.call(message, "techType"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.techType);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.uid);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.token);
            if (message.conId != null && Object.hasOwnProperty.call(message, "conId"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.conId);
            if (message.widgetId != null && Object.hasOwnProperty.call(message, "widgetId"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.widgetId);
            if (message.pageId != null && Object.hasOwnProperty.call(message, "pageId"))
                writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.pageId);
            if (message.preModId != null && Object.hasOwnProperty.call(message, "preModId"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.preModId);
            if (message.modId != null && Object.hasOwnProperty.call(message, "modId"))
                writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.modId);
            if (message.eventType != null && Object.hasOwnProperty.call(message, "eventType"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.eventType);
            if (message.eventTime != null && Object.hasOwnProperty.call(message, "eventTime"))
                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.eventTime);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.deviceId);
            if (message.ip != null && Object.hasOwnProperty.call(message, "ip"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.ip);
            if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                writer.uint32(/* id 16, wireType 1 =*/129).double(message.lng);
            if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                writer.uint32(/* id 17, wireType 1 =*/137).double(message.lat);
            if (message.screenX != null && Object.hasOwnProperty.call(message, "screenX"))
                writer.uint32(/* id 18, wireType 5 =*/149).float(message.screenX);
            if (message.screenY != null && Object.hasOwnProperty.call(message, "screenY"))
                writer.uint32(/* id 19, wireType 5 =*/157).float(message.screenY);
            if (message.conExt != null && Object.hasOwnProperty.call(message, "conExt"))
                writer.uint32(/* id 20, wireType 2 =*/162).bytes(message.conExt);
            return writer;
        };

        /**
         * Encodes the specified TraceMsg message, length delimited. Does not implicitly {@link pkg.TraceMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pkg.TraceMsg
         * @static
         * @param {pkg.ITraceMsg} message TraceMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TraceMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TraceMsg message from the specified reader or buffer.
         * @function decode
         * @memberof pkg.TraceMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pkg.TraceMsg} TraceMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TraceMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pkg.TraceMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.activeId = reader.uint32();
                        break;
                    }
                case 2: {
                        message.appType = reader.uint32();
                        break;
                    }
                case 3: {
                        message.version = reader.uint32();
                        break;
                    }
                case 4: {
                        message.techType = reader.uint32();
                        break;
                    }
                case 5: {
                        message.uid = reader.bytes();
                        break;
                    }
                case 6: {
                        message.token = reader.bytes();
                        break;
                    }
                case 7: {
                        message.conId = reader.bytes();
                        break;
                    }
                case 8: {
                        message.widgetId = reader.uint32();
                        break;
                    }
                case 9: {
                        message.pageId = reader.uint32();
                        break;
                    }
                case 10: {
                        message.preModId = reader.uint32();
                        break;
                    }
                case 11: {
                        message.modId = reader.uint32();
                        break;
                    }
                case 12: {
                        message.eventType = reader.uint32();
                        break;
                    }
                case 13: {
                        message.eventTime = reader.int64();
                        break;
                    }
                case 14: {
                        message.deviceId = reader.bytes();
                        break;
                    }
                case 15: {
                        message.ip = reader.int64();
                        break;
                    }
                case 16: {
                        message.lng = reader.double();
                        break;
                    }
                case 17: {
                        message.lat = reader.double();
                        break;
                    }
                case 18: {
                        message.screenX = reader.float();
                        break;
                    }
                case 19: {
                        message.screenY = reader.float();
                        break;
                    }
                case 20: {
                        message.conExt = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TraceMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pkg.TraceMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pkg.TraceMsg} TraceMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TraceMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TraceMsg message.
         * @function verify
         * @memberof pkg.TraceMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TraceMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.activeId != null && message.hasOwnProperty("activeId"))
                if (!$util.isInteger(message.activeId))
                    return "activeId: integer expected";
            if (message.appType != null && message.hasOwnProperty("appType"))
                if (!$util.isInteger(message.appType))
                    return "appType: integer expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isInteger(message.version))
                    return "version: integer expected";
            if (message.techType != null && message.hasOwnProperty("techType"))
                if (!$util.isInteger(message.techType))
                    return "techType: integer expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!(message.uid && typeof message.uid.length === "number" || $util.isString(message.uid)))
                    return "uid: buffer expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                    return "token: buffer expected";
            if (message.conId != null && message.hasOwnProperty("conId"))
                if (!(message.conId && typeof message.conId.length === "number" || $util.isString(message.conId)))
                    return "conId: buffer expected";
            if (message.widgetId != null && message.hasOwnProperty("widgetId"))
                if (!$util.isInteger(message.widgetId))
                    return "widgetId: integer expected";
            if (message.pageId != null && message.hasOwnProperty("pageId"))
                if (!$util.isInteger(message.pageId))
                    return "pageId: integer expected";
            if (message.preModId != null && message.hasOwnProperty("preModId"))
                if (!$util.isInteger(message.preModId))
                    return "preModId: integer expected";
            if (message.modId != null && message.hasOwnProperty("modId"))
                if (!$util.isInteger(message.modId))
                    return "modId: integer expected";
            if (message.eventType != null && message.hasOwnProperty("eventType"))
                if (!$util.isInteger(message.eventType))
                    return "eventType: integer expected";
            if (message.eventTime != null && message.hasOwnProperty("eventTime"))
                if (!$util.isInteger(message.eventTime) && !(message.eventTime && $util.isInteger(message.eventTime.low) && $util.isInteger(message.eventTime.high)))
                    return "eventTime: integer|Long expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!(message.deviceId && typeof message.deviceId.length === "number" || $util.isString(message.deviceId)))
                    return "deviceId: buffer expected";
            if (message.ip != null && message.hasOwnProperty("ip"))
                if (!$util.isInteger(message.ip) && !(message.ip && $util.isInteger(message.ip.low) && $util.isInteger(message.ip.high)))
                    return "ip: integer|Long expected";
            if (message.lng != null && message.hasOwnProperty("lng"))
                if (typeof message.lng !== "number")
                    return "lng: number expected";
            if (message.lat != null && message.hasOwnProperty("lat"))
                if (typeof message.lat !== "number")
                    return "lat: number expected";
            if (message.screenX != null && message.hasOwnProperty("screenX"))
                if (typeof message.screenX !== "number")
                    return "screenX: number expected";
            if (message.screenY != null && message.hasOwnProperty("screenY"))
                if (typeof message.screenY !== "number")
                    return "screenY: number expected";
            if (message.conExt != null && message.hasOwnProperty("conExt"))
                if (!(message.conExt && typeof message.conExt.length === "number" || $util.isString(message.conExt)))
                    return "conExt: buffer expected";
            return null;
        };

        /**
         * Creates a TraceMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pkg.TraceMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pkg.TraceMsg} TraceMsg
         */
        TraceMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.pkg.TraceMsg)
                return object;
            let message = new $root.pkg.TraceMsg();
            if (object.activeId != null)
                message.activeId = object.activeId >>> 0;
            if (object.appType != null)
                message.appType = object.appType >>> 0;
            if (object.version != null)
                message.version = object.version >>> 0;
            if (object.techType != null)
                message.techType = object.techType >>> 0;
            if (object.uid != null)
                if (typeof object.uid === "string")
                    $util.base64.decode(object.uid, message.uid = $util.newBuffer($util.base64.length(object.uid)), 0);
                else if (object.uid.length >= 0)
                    message.uid = object.uid;
            if (object.token != null)
                if (typeof object.token === "string")
                    $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                else if (object.token.length >= 0)
                    message.token = object.token;
            if (object.conId != null)
                if (typeof object.conId === "string")
                    $util.base64.decode(object.conId, message.conId = $util.newBuffer($util.base64.length(object.conId)), 0);
                else if (object.conId.length >= 0)
                    message.conId = object.conId;
            if (object.widgetId != null)
                message.widgetId = object.widgetId >>> 0;
            if (object.pageId != null)
                message.pageId = object.pageId >>> 0;
            if (object.preModId != null)
                message.preModId = object.preModId >>> 0;
            if (object.modId != null)
                message.modId = object.modId >>> 0;
            if (object.eventType != null)
                message.eventType = object.eventType >>> 0;
            if (object.eventTime != null)
                if ($util.Long)
                    (message.eventTime = $util.Long.fromValue(object.eventTime)).unsigned = false;
                else if (typeof object.eventTime === "string")
                    message.eventTime = parseInt(object.eventTime, 10);
                else if (typeof object.eventTime === "number")
                    message.eventTime = object.eventTime;
                else if (typeof object.eventTime === "object")
                    message.eventTime = new $util.LongBits(object.eventTime.low >>> 0, object.eventTime.high >>> 0).toNumber();
            if (object.deviceId != null)
                if (typeof object.deviceId === "string")
                    $util.base64.decode(object.deviceId, message.deviceId = $util.newBuffer($util.base64.length(object.deviceId)), 0);
                else if (object.deviceId.length >= 0)
                    message.deviceId = object.deviceId;
            if (object.ip != null)
                if ($util.Long)
                    (message.ip = $util.Long.fromValue(object.ip)).unsigned = false;
                else if (typeof object.ip === "string")
                    message.ip = parseInt(object.ip, 10);
                else if (typeof object.ip === "number")
                    message.ip = object.ip;
                else if (typeof object.ip === "object")
                    message.ip = new $util.LongBits(object.ip.low >>> 0, object.ip.high >>> 0).toNumber();
            if (object.lng != null)
                message.lng = Number(object.lng);
            if (object.lat != null)
                message.lat = Number(object.lat);
            if (object.screenX != null)
                message.screenX = Number(object.screenX);
            if (object.screenY != null)
                message.screenY = Number(object.screenY);
            if (object.conExt != null)
                if (typeof object.conExt === "string")
                    $util.base64.decode(object.conExt, message.conExt = $util.newBuffer($util.base64.length(object.conExt)), 0);
                else if (object.conExt.length >= 0)
                    message.conExt = object.conExt;
            return message;
        };

        /**
         * Creates a plain object from a TraceMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pkg.TraceMsg
         * @static
         * @param {pkg.TraceMsg} message TraceMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TraceMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.activeId = 0;
                object.appType = 0;
                object.version = 0;
                object.techType = 0;
                if (options.bytes === String)
                    object.uid = "";
                else {
                    object.uid = [];
                    if (options.bytes !== Array)
                        object.uid = $util.newBuffer(object.uid);
                }
                if (options.bytes === String)
                    object.token = "";
                else {
                    object.token = [];
                    if (options.bytes !== Array)
                        object.token = $util.newBuffer(object.token);
                }
                if (options.bytes === String)
                    object.conId = "";
                else {
                    object.conId = [];
                    if (options.bytes !== Array)
                        object.conId = $util.newBuffer(object.conId);
                }
                object.widgetId = 0;
                object.pageId = 0;
                object.preModId = 0;
                object.modId = 0;
                object.eventType = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.eventTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.eventTime = options.longs === String ? "0" : 0;
                if (options.bytes === String)
                    object.deviceId = "";
                else {
                    object.deviceId = [];
                    if (options.bytes !== Array)
                        object.deviceId = $util.newBuffer(object.deviceId);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ip = options.longs === String ? "0" : 0;
                object.lng = 0;
                object.lat = 0;
                object.screenX = 0;
                object.screenY = 0;
                if (options.bytes === String)
                    object.conExt = "";
                else {
                    object.conExt = [];
                    if (options.bytes !== Array)
                        object.conExt = $util.newBuffer(object.conExt);
                }
            }
            if (message.activeId != null && message.hasOwnProperty("activeId"))
                object.activeId = message.activeId;
            if (message.appType != null && message.hasOwnProperty("appType"))
                object.appType = message.appType;
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            if (message.techType != null && message.hasOwnProperty("techType"))
                object.techType = message.techType;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = options.bytes === String ? $util.base64.encode(message.uid, 0, message.uid.length) : options.bytes === Array ? Array.prototype.slice.call(message.uid) : message.uid;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
            if (message.conId != null && message.hasOwnProperty("conId"))
                object.conId = options.bytes === String ? $util.base64.encode(message.conId, 0, message.conId.length) : options.bytes === Array ? Array.prototype.slice.call(message.conId) : message.conId;
            if (message.widgetId != null && message.hasOwnProperty("widgetId"))
                object.widgetId = message.widgetId;
            if (message.pageId != null && message.hasOwnProperty("pageId"))
                object.pageId = message.pageId;
            if (message.preModId != null && message.hasOwnProperty("preModId"))
                object.preModId = message.preModId;
            if (message.modId != null && message.hasOwnProperty("modId"))
                object.modId = message.modId;
            if (message.eventType != null && message.hasOwnProperty("eventType"))
                object.eventType = message.eventType;
            if (message.eventTime != null && message.hasOwnProperty("eventTime"))
                if (typeof message.eventTime === "number")
                    object.eventTime = options.longs === String ? String(message.eventTime) : message.eventTime;
                else
                    object.eventTime = options.longs === String ? $util.Long.prototype.toString.call(message.eventTime) : options.longs === Number ? new $util.LongBits(message.eventTime.low >>> 0, message.eventTime.high >>> 0).toNumber() : message.eventTime;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = options.bytes === String ? $util.base64.encode(message.deviceId, 0, message.deviceId.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceId) : message.deviceId;
            if (message.ip != null && message.hasOwnProperty("ip"))
                if (typeof message.ip === "number")
                    object.ip = options.longs === String ? String(message.ip) : message.ip;
                else
                    object.ip = options.longs === String ? $util.Long.prototype.toString.call(message.ip) : options.longs === Number ? new $util.LongBits(message.ip.low >>> 0, message.ip.high >>> 0).toNumber() : message.ip;
            if (message.lng != null && message.hasOwnProperty("lng"))
                object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
            if (message.lat != null && message.hasOwnProperty("lat"))
                object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
            if (message.screenX != null && message.hasOwnProperty("screenX"))
                object.screenX = options.json && !isFinite(message.screenX) ? String(message.screenX) : message.screenX;
            if (message.screenY != null && message.hasOwnProperty("screenY"))
                object.screenY = options.json && !isFinite(message.screenY) ? String(message.screenY) : message.screenY;
            if (message.conExt != null && message.hasOwnProperty("conExt"))
                object.conExt = options.bytes === String ? $util.base64.encode(message.conExt, 0, message.conExt.length) : options.bytes === Array ? Array.prototype.slice.call(message.conExt) : message.conExt;
            return object;
        };

        /**
         * Converts this TraceMsg to JSON.
         * @function toJSON
         * @memberof pkg.TraceMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TraceMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TraceMsg
         * @function getTypeUrl
         * @memberof pkg.TraceMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TraceMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pkg.TraceMsg";
        };

        return TraceMsg;
    })();

    pkg.TraceMsgs = (function() {

        /**
         * Properties of a TraceMsgs.
         * @memberof pkg
         * @interface ITraceMsgs
         * @property {Array.<pkg.ITraceMsg>|null} [msgs] TraceMsgs msgs
         */

        /**
         * Constructs a new TraceMsgs.
         * @memberof pkg
         * @classdesc Represents a TraceMsgs.
         * @implements ITraceMsgs
         * @constructor
         * @param {pkg.ITraceMsgs=} [properties] Properties to set
         */
        function TraceMsgs(properties) {
            this.msgs = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TraceMsgs msgs.
         * @member {Array.<pkg.ITraceMsg>} msgs
         * @memberof pkg.TraceMsgs
         * @instance
         */
        TraceMsgs.prototype.msgs = $util.emptyArray;

        /**
         * Creates a new TraceMsgs instance using the specified properties.
         * @function create
         * @memberof pkg.TraceMsgs
         * @static
         * @param {pkg.ITraceMsgs=} [properties] Properties to set
         * @returns {pkg.TraceMsgs} TraceMsgs instance
         */
        TraceMsgs.create = function create(properties) {
            return new TraceMsgs(properties);
        };

        /**
         * Encodes the specified TraceMsgs message. Does not implicitly {@link pkg.TraceMsgs.verify|verify} messages.
         * @function encode
         * @memberof pkg.TraceMsgs
         * @static
         * @param {pkg.ITraceMsgs} message TraceMsgs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TraceMsgs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msgs != null && message.msgs.length)
                for (let i = 0; i < message.msgs.length; ++i)
                    $root.pkg.TraceMsg.encode(message.msgs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TraceMsgs message, length delimited. Does not implicitly {@link pkg.TraceMsgs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pkg.TraceMsgs
         * @static
         * @param {pkg.ITraceMsgs} message TraceMsgs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TraceMsgs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TraceMsgs message from the specified reader or buffer.
         * @function decode
         * @memberof pkg.TraceMsgs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pkg.TraceMsgs} TraceMsgs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TraceMsgs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pkg.TraceMsgs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.msgs && message.msgs.length))
                            message.msgs = [];
                        message.msgs.push($root.pkg.TraceMsg.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TraceMsgs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pkg.TraceMsgs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pkg.TraceMsgs} TraceMsgs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TraceMsgs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TraceMsgs message.
         * @function verify
         * @memberof pkg.TraceMsgs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TraceMsgs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msgs != null && message.hasOwnProperty("msgs")) {
                if (!Array.isArray(message.msgs))
                    return "msgs: array expected";
                for (let i = 0; i < message.msgs.length; ++i) {
                    let error = $root.pkg.TraceMsg.verify(message.msgs[i]);
                    if (error)
                        return "msgs." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TraceMsgs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pkg.TraceMsgs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pkg.TraceMsgs} TraceMsgs
         */
        TraceMsgs.fromObject = function fromObject(object) {
            if (object instanceof $root.pkg.TraceMsgs)
                return object;
            let message = new $root.pkg.TraceMsgs();
            if (object.msgs) {
                if (!Array.isArray(object.msgs))
                    throw TypeError(".pkg.TraceMsgs.msgs: array expected");
                message.msgs = [];
                for (let i = 0; i < object.msgs.length; ++i) {
                    if (typeof object.msgs[i] !== "object")
                        throw TypeError(".pkg.TraceMsgs.msgs: object expected");
                    message.msgs[i] = $root.pkg.TraceMsg.fromObject(object.msgs[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TraceMsgs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pkg.TraceMsgs
         * @static
         * @param {pkg.TraceMsgs} message TraceMsgs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TraceMsgs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.msgs = [];
            if (message.msgs && message.msgs.length) {
                object.msgs = [];
                for (let j = 0; j < message.msgs.length; ++j)
                    object.msgs[j] = $root.pkg.TraceMsg.toObject(message.msgs[j], options);
            }
            return object;
        };

        /**
         * Converts this TraceMsgs to JSON.
         * @function toJSON
         * @memberof pkg.TraceMsgs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TraceMsgs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TraceMsgs
         * @function getTypeUrl
         * @memberof pkg.TraceMsgs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TraceMsgs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pkg.TraceMsgs";
        };

        return TraceMsgs;
    })();

    pkg.SlsVideoTraceMsg = (function() {

        /**
         * Properties of a SlsVideoTraceMsg.
         * @memberof pkg
         * @interface ISlsVideoTraceMsg
         * @property {pkg.ITraceMsg|null} [tm] SlsVideoTraceMsg tm
         * @property {number|Long|null} [totalTime] SlsVideoTraceMsg totalTime
         * @property {number|Long|null} [positionTime] SlsVideoTraceMsg positionTime
         * @property {number|Long|null} [durationTime] SlsVideoTraceMsg durationTime
         */

        /**
         * Constructs a new SlsVideoTraceMsg.
         * @memberof pkg
         * @classdesc Represents a SlsVideoTraceMsg.
         * @implements ISlsVideoTraceMsg
         * @constructor
         * @param {pkg.ISlsVideoTraceMsg=} [properties] Properties to set
         */
        function SlsVideoTraceMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SlsVideoTraceMsg tm.
         * @member {pkg.ITraceMsg|null|undefined} tm
         * @memberof pkg.SlsVideoTraceMsg
         * @instance
         */
        SlsVideoTraceMsg.prototype.tm = null;

        /**
         * SlsVideoTraceMsg totalTime.
         * @member {number|Long} totalTime
         * @memberof pkg.SlsVideoTraceMsg
         * @instance
         */
        SlsVideoTraceMsg.prototype.totalTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SlsVideoTraceMsg positionTime.
         * @member {number|Long} positionTime
         * @memberof pkg.SlsVideoTraceMsg
         * @instance
         */
        SlsVideoTraceMsg.prototype.positionTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SlsVideoTraceMsg durationTime.
         * @member {number|Long} durationTime
         * @memberof pkg.SlsVideoTraceMsg
         * @instance
         */
        SlsVideoTraceMsg.prototype.durationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SlsVideoTraceMsg instance using the specified properties.
         * @function create
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {pkg.ISlsVideoTraceMsg=} [properties] Properties to set
         * @returns {pkg.SlsVideoTraceMsg} SlsVideoTraceMsg instance
         */
        SlsVideoTraceMsg.create = function create(properties) {
            return new SlsVideoTraceMsg(properties);
        };

        /**
         * Encodes the specified SlsVideoTraceMsg message. Does not implicitly {@link pkg.SlsVideoTraceMsg.verify|verify} messages.
         * @function encode
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {pkg.ISlsVideoTraceMsg} message SlsVideoTraceMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SlsVideoTraceMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tm != null && Object.hasOwnProperty.call(message, "tm"))
                $root.pkg.TraceMsg.encode(message.tm, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.totalTime != null && Object.hasOwnProperty.call(message, "totalTime"))
                writer.uint32(/* id 101, wireType 0 =*/808).int64(message.totalTime);
            if (message.positionTime != null && Object.hasOwnProperty.call(message, "positionTime"))
                writer.uint32(/* id 102, wireType 0 =*/816).int64(message.positionTime);
            if (message.durationTime != null && Object.hasOwnProperty.call(message, "durationTime"))
                writer.uint32(/* id 103, wireType 0 =*/824).int64(message.durationTime);
            return writer;
        };

        /**
         * Encodes the specified SlsVideoTraceMsg message, length delimited. Does not implicitly {@link pkg.SlsVideoTraceMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {pkg.ISlsVideoTraceMsg} message SlsVideoTraceMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SlsVideoTraceMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SlsVideoTraceMsg message from the specified reader or buffer.
         * @function decode
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pkg.SlsVideoTraceMsg} SlsVideoTraceMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SlsVideoTraceMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pkg.SlsVideoTraceMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.tm = $root.pkg.TraceMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 101: {
                        message.totalTime = reader.int64();
                        break;
                    }
                case 102: {
                        message.positionTime = reader.int64();
                        break;
                    }
                case 103: {
                        message.durationTime = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SlsVideoTraceMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pkg.SlsVideoTraceMsg} SlsVideoTraceMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SlsVideoTraceMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SlsVideoTraceMsg message.
         * @function verify
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SlsVideoTraceMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tm != null && message.hasOwnProperty("tm")) {
                let error = $root.pkg.TraceMsg.verify(message.tm);
                if (error)
                    return "tm." + error;
            }
            if (message.totalTime != null && message.hasOwnProperty("totalTime"))
                if (!$util.isInteger(message.totalTime) && !(message.totalTime && $util.isInteger(message.totalTime.low) && $util.isInteger(message.totalTime.high)))
                    return "totalTime: integer|Long expected";
            if (message.positionTime != null && message.hasOwnProperty("positionTime"))
                if (!$util.isInteger(message.positionTime) && !(message.positionTime && $util.isInteger(message.positionTime.low) && $util.isInteger(message.positionTime.high)))
                    return "positionTime: integer|Long expected";
            if (message.durationTime != null && message.hasOwnProperty("durationTime"))
                if (!$util.isInteger(message.durationTime) && !(message.durationTime && $util.isInteger(message.durationTime.low) && $util.isInteger(message.durationTime.high)))
                    return "durationTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a SlsVideoTraceMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pkg.SlsVideoTraceMsg} SlsVideoTraceMsg
         */
        SlsVideoTraceMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.pkg.SlsVideoTraceMsg)
                return object;
            let message = new $root.pkg.SlsVideoTraceMsg();
            if (object.tm != null) {
                if (typeof object.tm !== "object")
                    throw TypeError(".pkg.SlsVideoTraceMsg.tm: object expected");
                message.tm = $root.pkg.TraceMsg.fromObject(object.tm);
            }
            if (object.totalTime != null)
                if ($util.Long)
                    (message.totalTime = $util.Long.fromValue(object.totalTime)).unsigned = false;
                else if (typeof object.totalTime === "string")
                    message.totalTime = parseInt(object.totalTime, 10);
                else if (typeof object.totalTime === "number")
                    message.totalTime = object.totalTime;
                else if (typeof object.totalTime === "object")
                    message.totalTime = new $util.LongBits(object.totalTime.low >>> 0, object.totalTime.high >>> 0).toNumber();
            if (object.positionTime != null)
                if ($util.Long)
                    (message.positionTime = $util.Long.fromValue(object.positionTime)).unsigned = false;
                else if (typeof object.positionTime === "string")
                    message.positionTime = parseInt(object.positionTime, 10);
                else if (typeof object.positionTime === "number")
                    message.positionTime = object.positionTime;
                else if (typeof object.positionTime === "object")
                    message.positionTime = new $util.LongBits(object.positionTime.low >>> 0, object.positionTime.high >>> 0).toNumber();
            if (object.durationTime != null)
                if ($util.Long)
                    (message.durationTime = $util.Long.fromValue(object.durationTime)).unsigned = false;
                else if (typeof object.durationTime === "string")
                    message.durationTime = parseInt(object.durationTime, 10);
                else if (typeof object.durationTime === "number")
                    message.durationTime = object.durationTime;
                else if (typeof object.durationTime === "object")
                    message.durationTime = new $util.LongBits(object.durationTime.low >>> 0, object.durationTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SlsVideoTraceMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {pkg.SlsVideoTraceMsg} message SlsVideoTraceMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SlsVideoTraceMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.tm = null;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.totalTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.totalTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.positionTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.positionTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.durationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.durationTime = options.longs === String ? "0" : 0;
            }
            if (message.tm != null && message.hasOwnProperty("tm"))
                object.tm = $root.pkg.TraceMsg.toObject(message.tm, options);
            if (message.totalTime != null && message.hasOwnProperty("totalTime"))
                if (typeof message.totalTime === "number")
                    object.totalTime = options.longs === String ? String(message.totalTime) : message.totalTime;
                else
                    object.totalTime = options.longs === String ? $util.Long.prototype.toString.call(message.totalTime) : options.longs === Number ? new $util.LongBits(message.totalTime.low >>> 0, message.totalTime.high >>> 0).toNumber() : message.totalTime;
            if (message.positionTime != null && message.hasOwnProperty("positionTime"))
                if (typeof message.positionTime === "number")
                    object.positionTime = options.longs === String ? String(message.positionTime) : message.positionTime;
                else
                    object.positionTime = options.longs === String ? $util.Long.prototype.toString.call(message.positionTime) : options.longs === Number ? new $util.LongBits(message.positionTime.low >>> 0, message.positionTime.high >>> 0).toNumber() : message.positionTime;
            if (message.durationTime != null && message.hasOwnProperty("durationTime"))
                if (typeof message.durationTime === "number")
                    object.durationTime = options.longs === String ? String(message.durationTime) : message.durationTime;
                else
                    object.durationTime = options.longs === String ? $util.Long.prototype.toString.call(message.durationTime) : options.longs === Number ? new $util.LongBits(message.durationTime.low >>> 0, message.durationTime.high >>> 0).toNumber() : message.durationTime;
            return object;
        };

        /**
         * Converts this SlsVideoTraceMsg to JSON.
         * @function toJSON
         * @memberof pkg.SlsVideoTraceMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SlsVideoTraceMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SlsVideoTraceMsg
         * @function getTypeUrl
         * @memberof pkg.SlsVideoTraceMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SlsVideoTraceMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pkg.SlsVideoTraceMsg";
        };

        return SlsVideoTraceMsg;
    })();

    pkg.SlsVideoTraceMsgs = (function() {

        /**
         * Properties of a SlsVideoTraceMsgs.
         * @memberof pkg
         * @interface ISlsVideoTraceMsgs
         * @property {Array.<pkg.ISlsVideoTraceMsg>|null} [slsMsg] SlsVideoTraceMsgs slsMsg
         */

        /**
         * Constructs a new SlsVideoTraceMsgs.
         * @memberof pkg
         * @classdesc Represents a SlsVideoTraceMsgs.
         * @implements ISlsVideoTraceMsgs
         * @constructor
         * @param {pkg.ISlsVideoTraceMsgs=} [properties] Properties to set
         */
        function SlsVideoTraceMsgs(properties) {
            this.slsMsg = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SlsVideoTraceMsgs slsMsg.
         * @member {Array.<pkg.ISlsVideoTraceMsg>} slsMsg
         * @memberof pkg.SlsVideoTraceMsgs
         * @instance
         */
        SlsVideoTraceMsgs.prototype.slsMsg = $util.emptyArray;

        /**
         * Creates a new SlsVideoTraceMsgs instance using the specified properties.
         * @function create
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {pkg.ISlsVideoTraceMsgs=} [properties] Properties to set
         * @returns {pkg.SlsVideoTraceMsgs} SlsVideoTraceMsgs instance
         */
        SlsVideoTraceMsgs.create = function create(properties) {
            return new SlsVideoTraceMsgs(properties);
        };

        /**
         * Encodes the specified SlsVideoTraceMsgs message. Does not implicitly {@link pkg.SlsVideoTraceMsgs.verify|verify} messages.
         * @function encode
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {pkg.ISlsVideoTraceMsgs} message SlsVideoTraceMsgs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SlsVideoTraceMsgs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.slsMsg != null && message.slsMsg.length)
                for (let i = 0; i < message.slsMsg.length; ++i)
                    $root.pkg.SlsVideoTraceMsg.encode(message.slsMsg[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SlsVideoTraceMsgs message, length delimited. Does not implicitly {@link pkg.SlsVideoTraceMsgs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {pkg.ISlsVideoTraceMsgs} message SlsVideoTraceMsgs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SlsVideoTraceMsgs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SlsVideoTraceMsgs message from the specified reader or buffer.
         * @function decode
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {pkg.SlsVideoTraceMsgs} SlsVideoTraceMsgs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SlsVideoTraceMsgs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.pkg.SlsVideoTraceMsgs();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.slsMsg && message.slsMsg.length))
                            message.slsMsg = [];
                        message.slsMsg.push($root.pkg.SlsVideoTraceMsg.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SlsVideoTraceMsgs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {pkg.SlsVideoTraceMsgs} SlsVideoTraceMsgs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SlsVideoTraceMsgs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SlsVideoTraceMsgs message.
         * @function verify
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SlsVideoTraceMsgs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.slsMsg != null && message.hasOwnProperty("slsMsg")) {
                if (!Array.isArray(message.slsMsg))
                    return "slsMsg: array expected";
                for (let i = 0; i < message.slsMsg.length; ++i) {
                    let error = $root.pkg.SlsVideoTraceMsg.verify(message.slsMsg[i]);
                    if (error)
                        return "slsMsg." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SlsVideoTraceMsgs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {pkg.SlsVideoTraceMsgs} SlsVideoTraceMsgs
         */
        SlsVideoTraceMsgs.fromObject = function fromObject(object) {
            if (object instanceof $root.pkg.SlsVideoTraceMsgs)
                return object;
            let message = new $root.pkg.SlsVideoTraceMsgs();
            if (object.slsMsg) {
                if (!Array.isArray(object.slsMsg))
                    throw TypeError(".pkg.SlsVideoTraceMsgs.slsMsg: array expected");
                message.slsMsg = [];
                for (let i = 0; i < object.slsMsg.length; ++i) {
                    if (typeof object.slsMsg[i] !== "object")
                        throw TypeError(".pkg.SlsVideoTraceMsgs.slsMsg: object expected");
                    message.slsMsg[i] = $root.pkg.SlsVideoTraceMsg.fromObject(object.slsMsg[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SlsVideoTraceMsgs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {pkg.SlsVideoTraceMsgs} message SlsVideoTraceMsgs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SlsVideoTraceMsgs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.slsMsg = [];
            if (message.slsMsg && message.slsMsg.length) {
                object.slsMsg = [];
                for (let j = 0; j < message.slsMsg.length; ++j)
                    object.slsMsg[j] = $root.pkg.SlsVideoTraceMsg.toObject(message.slsMsg[j], options);
            }
            return object;
        };

        /**
         * Converts this SlsVideoTraceMsgs to JSON.
         * @function toJSON
         * @memberof pkg.SlsVideoTraceMsgs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SlsVideoTraceMsgs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SlsVideoTraceMsgs
         * @function getTypeUrl
         * @memberof pkg.SlsVideoTraceMsgs
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SlsVideoTraceMsgs.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/pkg.SlsVideoTraceMsgs";
        };

        return SlsVideoTraceMsgs;
    })();

    return pkg;
})();

export { $root as default };
